import { BaseSEOOutputDTO } from '../../common.models/baseSEOOutputDTO.model';

export class ProductTypeGetDetailOutputDTO extends BaseSEOOutputDTO {
    id: number;
    title: string;
    description: string;
    imageAddressHighQuality: string;
    imageAddressLowQuality: string;

    constructor() {
        super();

        this.id = 0;
        this.title = "";
        this.description = "";
        this.imageAddressHighQuality = "";
        this.imageAddressLowQuality = "";
    }
}